import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import { Formik, Form } from "formik";
import * as Yup from "yup";

import { loginProfessor, verifyOtpAction } from "services/actions";

import { resendActivationData } from "services/api";
import { globalData } from "services/cms/actions";
import { withTranslation, Trans } from 'react-i18next';
import {clear} from "services/storage";

import { set, get } from "services/storage";
import { images } from "../../../home/_resources";

import ModalPassword from "../../../children/home/components/ModalPassword"
import ModalCompteSuccess from "../../../children/home/components/ModalCompteSuccess";
import LdsSpinner from 'components/LdsSpinner';
import {QRCodeSVG} from 'qrcode.react';

class CommonModalConnexion extends Component {
  constructor(props){
    super(props);
    this.device_width = window.innerWidth;
    this.state = {
      is_tablete: this.device_width < 1200,
      is_mobile: this.device_width < 767,
      open: false,
      success: false,
      messageSuccess: "",
      resend_activation_data: "",
      resend_activation_data_message: "",
      username: "",
      mfaPassword: "",
      key_inv: this.props.key_inv,
      errorGlobal:"",
      isSubmitting: false,
      // OTP related states
      showOtpInput: false,
      otpData: null,
      otpCode: "",
      otpError: "",
      // MFA Setup states
      mfaSetupMode: false,
      mfaOtpOnly: false,
      showManualSecret: false,
      mfaSetupStep: 0  // 0: Download app, 1: Scan QR, 2: Enter code
    };
  }

  handleCloseCnxConnexion = () => {
    this.props.handleCloseCnxConnexion();
  };

  handlePasswordReseted = (message) => {
    this.setState({
      success: true,
      messageSuccess: message,
      open: false
    });
  };

  handleCloseSuccess = () => {
    this.setState({
      success: false,
      messageSuccess: ""
    });
  };

  getValidationSchema = () => {
    if (this.state.showOtpInput) {
      return Yup.object().shape({
        otp: Yup.string()
          .length(6, this.props.t("OTP must be 6 digits"))
          .required(this.props.t("OTP required"))
      });
    }
    
    return Yup.object().shape({
      username: Yup.string().required(this.props.t("Username required")),
      password: Yup.string()
        .required(this.props.t("Password required"))
    });
  };

  onOpenModalPassword = () => {
    this.setState({
      open: true
    });
  };

  onCloseModalPassword = () => {
    this.setState({
      open: false
    });
  };

  handleResendActivationData = () => {
    
    let account;
    account = {
      username: this.state.username
    };
    resendActivationData(account)
    .then(data => {
      this.setState({resend_activation_data_message: data.message});
    })
    .catch(err => {
      this.setState(state => ({
        errorGlobal: err.message
      }));
    });
  };

  handleSubmit = form => {
    if (this.state.showOtpInput) {
      return this.handleOtpSubmit(form);
    }

    let loginprof = this.props.addedData || {};
    if(this.props.addedData){
      loginprof.added_action = "add_school";
    }
    loginprof.username = form.username;
    loginprof.password = form.password;
    loginprof.page_front = this.props.pages;
    
    var lev = get("level_groups");
    var current_language = get("current_language"),
      device_token = get("device_token");
    clear();
    set("device_token", device_token);
    set("level_groups", lev);
    set("current_language", current_language);
    
    return this.props
      .dispatch(loginProfessor(loginprof))
      .then(data => {
        console.log(data)
        if (data.payload.success) {
          this.redirectAfterLogin();
        } else if (data.payload.is_otp) {
          // Handle OTP requirement
          this.setState({
            showOtpInput: 'OTP',
            otpData: data.payload,
            mfaSetupMode: false,
            errorGlobal: "",
            isSubmitting: false
          });
        }
        else if (data.payload.is_mfa_otp){
          // MFA OTP only (user already has MFA setup)
          this.setState({
            showOtpInput: "MFA",
            otpData: data.payload,
            mfaOtpOnly: true,
            mfaSetupMode: false,
            errorGlobal: "",
            isSubmitting: false,
            mfaPassword: form.password,
            username: form.username
          });
        }
        else if (data.payload.is_mfa){
          // Check if it's MFA setup (new) or verification (existing)
          const isMfaSetup = data.payload.uri ? true : false;
          this.setState({
            showOtpInput: "MFA",
            otpData: data.payload,
            mfaSetupMode: isMfaSetup,
            mfaOtpOnly: false,
            username: form.username,
            mfaPassword: form.password,
            errorGlobal: "",
            isSubmitting: false,
            mfaSetupStep: isMfaSetup ? 0 : 1  // Start at step 0 for new setup, step 1 for verification
          });
        }
      })
      .catch(err => {
        var message = err.message || "";
        var resend_activation_data = message.indexOf("mail_not_yet_verified") !== -1 ? "mail" :(message.indexOf("phone_not_yet_verified") !== -1 ? "phone" : "");
        this.setState(state => ({
          errorGlobal: message.replace(",mail_not_yet_verified", "").replace(",phone_not_yet_verified", ""),
          resend_activation_data: resend_activation_data,
          resend_activation_data_message: "",
          username: form.username,
          isSubmitting: false
        }));
      });
  }

  handleOtpSubmit = (form) => {
    const isMfaSetup = this.state.mfaSetupMode;
    const isMfaOtpOnly = this.state.mfaOtpOnly;
    
    const otpData = {
      user_id: this.state.otpData.user_id,
      ...(isMfaOtpOnly ? { 
        mfa_otp: form.otp,
        username: this.state.username,
        password: this.state.mfaPassword
      } : isMfaSetup ? { 
        mfa_code: form.otp,
        username: this.state.username,
        password: this.state.mfaPassword
      } : { otp: form.otp }),
      ...(!isMfaSetup && !isMfaOtpOnly && this.props.addedData)
    };

    if(!isMfaSetup && !isMfaOtpOnly && this.props.addedData){
      otpData.added_action = "add_school";
    }
    if(!isMfaSetup && !isMfaOtpOnly) {
      otpData.page_front = this.props.pages;
    }

    return this.props
      .dispatch(verifyOtpAction(otpData))
      .then(data => {
        if (data.payload.success) {
          if(isMfaSetup || isMfaOtpOnly) {
            // MFA setup or MFA verification successful - auto login
            this.redirectAfterLogin();
          } else {
            // Regular OTP verification
            this.redirectAfterLogin();
          }
        }
      })
      // .catch(err => {
      //   let errorMessage = err.message || this.props.t("Invalid OTP");
        
      //   // Handle specific OTP error cases
      //   if (errorMessage.includes("Invalid OTP") || errorMessage.includes("invalid_otp")) {
      //     errorMessage = this.props.t("Invalid OTP. Please check the code and try again.");
      //   } else if (errorMessage.includes("expired") || errorMessage.includes("OTP expired")) {
      //     errorMessage = this.props.t("OTP has expired. Please request a new code.");
      //   }
        
      //   this.setState({
      //     otpError: errorMessage,
      //     isSubmitting: false
      //   });
      // });
      .catch(err => {
        // Get error message from either err.message or err.response.data.message
        let errorMessage = err.message;
        if (!errorMessage && err.response && err.response.data) {
          errorMessage = err.response.data.message;
        }
        
        // During OTP verification, always show OTP-specific error message
        if (errorMessage) {
          errorMessage = errorMessage.toLowerCase();
          
          if (errorMessage.includes("invalid") && errorMessage.includes("otp")) {
            errorMessage = this.props.t("The authentication code you entered is incorrect. Please try again.");
          } else if (errorMessage.includes("invalid") || errorMessage.includes("incorrect")) {
            errorMessage = this.props.t("Invalid authentication code. Please check and try again.");
          } else if (errorMessage.includes("expired")) {
            errorMessage = this.props.t("Your authentication code has expired. Please request a new one.");
          } else if (errorMessage.includes("used") || errorMessage.includes("already")) {
            errorMessage = this.props.t("This authentication code has already been used. Please enter a new one.");
          } else {
            // Default OTP error message for any other error during OTP verification
            errorMessage = this.props.t("The authentication code is not correct. Please try again.");
          }
        } else {
          errorMessage = this.props.t("The authentication code is not correct. Please try again.");
        }
        
        this.setState({
          otpError: errorMessage,
          isSubmitting: false
        });
      });
  };

  redirectAfterLogin = () => {
    const user = get("session_user");
    
    if(this.props.pages === "school"){
      if(user.profile.is_escort){
        this.props.history.push("/escort/transport");
      }
      else{
        if(!user.profile.is_school_admin)
          this.props.dispatch(globalData({}));
        this.props.history.push("/");
      }
    }else if (this.props.pages === "parent") {
      if(['pa', 'pr_pa'].indexOf(user.account_type) >= 0 || user.account_type.indexOf('pa') != -1){
        this.props.history.push("/parents/dashboard");
      }
      else if(user.profile.is_escort){
        this.props.history.push("/escort/transport");
      }
      else if(this.props.key_inv){
        this.props.dispatch(globalData({}));
        this.props.history.push("/parents/dashboard?key_inv=" + this.props.key_inv);
      }
      else{
        if(['pa', 'pr_pa'].indexOf(user.account_type) >= 0){
          this.props.dispatch(globalData({}));
          this.props.history.push("/parents/dashboard");
        }
        else
          this.props.history.push("/");
      }
    }else if (this.props.pages === "professor") {
      if(['pr', 'pr_pa'].indexOf(user.account_type) >= 0 && ((user.schools || user.profile && user.profile.schools || []).length > 0 || user.profile && user.profile.had_sanady_school_from_last_year)){
        if(false && !((user.schools || user.profile && user.profile.schools || []).length > 0)){
          this.props.history.push(`/professor/info_profile`);
        }
        else{
        this.props.dispatch(globalData({}));
          if(user.profile.schools.findIndex(sc => sc.group_id == 249) >= 0)
            this.props.history.push(`/professor/activities_prescolaire`);
          else
            this.props.history.push(`/professor/classes`);
        }
      }
      else if(user.profile.is_escort){
        this.props.history.push("/escort/transport");
      }
      else if(user.profile.is_school_admin){
        this.props.history.push("/");
      }
      else if(this.props.key_inv){
        this.props.dispatch(globalData({}));
        this.props.history.push("/parents/dashboard?key_inv=" + this.props.key_inv);
      }
      else if(['pa', 'pr_pa'].indexOf(user.account_type) >= 0){
        this.props.history.push("/parents/dashboard");
      }
      else{
        this.props.history.push("/");
      }
    } else {
      if(user.profile.is_escort){
        this.props.history.push("/escort/transport");
      }
      else if(['pr','pr_pa'].indexOf(user.account_type) >= 0 && ((user.schools || user.profile && user.profile.schools || []).length > 0 || user.profile && user.profile.had_sanady_school_from_last_year)){
        if(false && !((user.schools || user.profile && user.profile.schools || []).length > 0)){
          this.props.history.push(`/professor/info_profile`);
        }
        else{
        this.props.dispatch(globalData({}));
          if(user.profile.schools.findIndex(sc => sc.group_id == 249) >= 0)
            this.props.history.push(`/professor/activities_prescolaire`);
          else
            this.props.history.push(`/professor/classes`);
        }
      }
      else
        this.props.history.push("/");
    }
  };

  handleBackToLogin = () => {
    this.setState({
      showOtpInput: false,
      otpData: null,
      otpCode: "",
      otpError: "",
      errorGlobal: "",
      mfaSetupMode: false,
      mfaOtpOnly: false,
      showManualSecret: false,
      mfaPassword: "",
      mfaSetupStep: 0
    });
  };

  render() {
    const {resend_activation_data, resend_activation_data_message, isSubmitting, showOtpInput, otpError, mfaSetupMode, mfaOtpOnly, mfaSetupStep} = this.state;
    const mfaUri = mfaSetupMode && this.state.otpData && this.state.otpData.uri ? this.state.otpData.uri : null;
    const mfaSecret = mfaUri ? mfaUri.split('secret=')[1] : null;
    
    return (
        <>
      <Modal
        open={this.props.openProfessor}
        onClose={this.handleCloseCnxConnexion}
        showCloseIcon={false}
        center
        classNames={{
          overlay: { dialogOverlay: "white" },
          modal: { dialog: "white", dialogConnexion: "white", dialogCommonConnexion: "white", web: !(this.state.is_tablete || this.state.is_mobile) ? "white" : "", tablete: this.state.is_tablete && !this.state.is_mobile ? "white" : "", mobile: this.state.is_mobile ? "white" : "" }
        }}
      >
        <div className={"row " + (this.state.is_mobile ? " mobile " : this.state.is_tablete ? " tablete " : "web")}>
          <div className="col col-md-6 form_">
            <div className="connexion_form">
              <h2>
                {showOtpInput === 'MFA' && mfaSetupMode ? this.props.t('Set Up Two-Factor Authentication') : showOtpInput === 'MFA' && mfaOtpOnly ? this.props.t('Two-Factor Authentication') : showOtpInput ? this.props.t('Enter Verification Code') : this.props.t('Sign in')}
              </h2>
              
              {showOtpInput === 'OTP' && (
                <div style={{marginBottom: 15, color: '#666'}}>
                  {this.props.t('A verification code has been sent to your phone. Please enter it below.')}
                </div>
              )}
              {showOtpInput === 'MFA' && !mfaSetupMode && mfaOtpOnly && (
                <div style={{marginBottom: 15, color: '#666'}}>
                  {this.props.t('Enter your 6-digit authentication code from your authenticator app.')}
                </div>
              )}
              {showOtpInput === 'MFA' && !mfaSetupMode && !mfaOtpOnly && (
                <div style={{marginBottom: 15, color: '#666'}}>
                  {this.props.t('Enter your 6-digit authentication code.')}
                </div>
              )}

              <Formik
                key={showOtpInput ? showOtpInput === 'OTP' ? 'otp': 'mfa' : 'login'} // Force re-render when switching forms
                initialValues={showOtpInput ? { otp: "" } : {
                  username: this.props.username || "",
                  password: ""
                }}
                validationSchema={this.getValidationSchema}
                onSubmit={values => {
                  this.setState({
                    isSubmitting: true,
                    otpError: "", // Clear previous OTP errors
                    errorGlobal: "" // Clear previous login errors
                  });
                  this.handleSubmit(values);
                }}
              > 
                {({ errors, touched, values, handleChange }) => {
                  return (<Form>
                    {(this.state.errorGlobal || otpError) && (                    
                      <div className="textErrors" style={{color: "red", paddingBottom: 10, fontSize: "12px"}}>
                        {showOtpInput ? otpError : this.props.t(this.state.errorGlobal)}
                      </div>
                    )}
                    <span
                      className="schoolClose hidden"
                      onClick={() => this.handleCloseCnxConnexion()}
                    >
                    &times;
                  </span>
                  <div className="modalConnexionForm">
                    {showOtpInput && mfaSetupMode && mfaSetupStep === 0 && (
                      // MFA Setup Step 0: Download App
                      <div className="connexionLigne">
                        <div className="connexionW100" style={{textAlign: 'center', marginBottom: 20}}>
                          <p style={{marginBottom: 15, fontSize: '16px', fontWeight: 'bold'}}>{this.props.t('Step 1: Download Authenticator App')}</p>
                          <p style={{marginBottom: 20, fontSize: '14px', color: '#555'}}>
                            {this.props.t('Scan one of these QR codes to download Google Authenticator:')}
                          </p>
                          
                          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', gap: '20px', marginBottom: 20}}>
                            {/* Android - Google Play */}
                            <div style={{backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px', textAlign: 'center'}}>
                              <p style={{fontSize: '12px', fontWeight: 'bold', marginBottom: '8px'}}>Android (Google Play)</p>
                              <img 
                                src={require('../../../../assets/img/authplaystore.png')} 
                                alt="Google Authenticator Android QR Code"
                                style={{width: '150px', height: '150px', border: '1px solid #ddd', borderRadius: '4px'}}
                              />
                            </div>

                            {/* iOS - Apple App Store */}
                            <div style={{backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px', textAlign: 'center'}}>
                              <p style={{fontSize: '12px', fontWeight: 'bold', marginBottom: '8px'}}>iOS (App Store)</p>
                              <img 
                                src={require('../../../../assets/img/authappstore.png')} 
                                alt="Google Authenticator iOS QR Code"
                                style={{width: '150px', height: '150px', border: '1px solid #ddd', borderRadius: '4px'}}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {showOtpInput && mfaSetupMode && mfaSetupStep === 1 && (
                      // MFA Setup Step 1: Scan QR Code
                      <div className="connexionLigne">
                        <div className="connexionW100" style={{textAlign: 'center', marginBottom: 20}}>
                          <p style={{marginBottom: 10, fontSize: '14px'}}>{this.props.t('Step 2: Scan QR Code From Google Authenticator')}</p>
                          <QRCodeSVG 
                            value={mfaUri} 
                            size={200}
                            level="H"
                            includeMargin={true}
                          />
                        </div>
                        
                        <div className="connexionW100">
                          <p style={{marginBottom: 10, fontSize: '14px'}}>{this.props.t('Step 3: Enter the 6-digit code from your app')}</p>
                          <label className="hidden">{this.props.t('Enter verification code')}</label>
                          <div style={{display: 'flex', gap: '8px', alignItems: 'flex-start'}}>
                            <input 
                              type="text"
                              className={`textInput ${(errors.otp || otpError) && "textInputError"}`}
                              name="otp"
                              value={values.otp}
                              onChange={(e) => {
                                handleChange(e);
                                // Clear OTP error when user starts typing
                                if (this.state.otpError) {
                                  this.setState({ otpError: "" });
                                }
                              }}
                              placeholder={this.props.t('Enter 6-digit code')}
                              maxLength="6"
                              pattern="[0-9]*"
                              inputMode="numeric"
                              autoFocus
                              style={{flex: 1}}
                            />
                            <button 
                              type="submit" 
                              className="signin home_btn_connexion"
                              disabled={isSubmitting}
                              style={{
                                padding: '8px 16px',
                                marginTop: 0,
                                whiteSpace: 'nowrap'
                              }}
                            >
                              {isSubmitting ? <LdsSpinner type='relative'/> : this.props.t('Verify')}
                            </button>
                          </div>
                          {errors.otp && touched.otp ? (
                            <div className="textErrors">{errors.otp}</div>
                          ) : null}
                        </div>
                      </div>
                    )}
                    {showOtpInput && mfaSetupMode && mfaSetupStep === 0 && (
                      // Step 0 buttons: Only Next
                      <div className="connexionLigne w12 justify-content-between" style={{marginTop: 20}}>
                        <a onClick={this.handleBackToLogin} className="forgot" style={{float:'none'}}>
                          {this.props.t('Back to Login')}
                        </a>
                        <button 
                          type="button" 
                          onClick={() => this.setState({mfaSetupStep: 1})}
                          style={{
                            padding: '8px 16px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px'
                          }}
                        >
                          {this.props.t('Suivant')}
                        </button>
                      </div>
                    )}
                    {showOtpInput && !mfaSetupMode ? (
                      // Regular OTP/MFA verification Input Form
                      <div className="connexionLigne">
                        <div className="connexionW100">
                          <label className="hidden">{this.props.t('Enter verification code')}</label>
                          <input 
                            type="text"
                            className={`textInput ${(errors.otp || otpError) && "textInputError"}`}
                            name="otp"
                            value={values.otp}
                            onChange={(e) => {
                              handleChange(e);
                              // Clear OTP error when user starts typing
                              if (this.state.otpError) {
                                this.setState({ otpError: "" });
                              }
                            }}
                            placeholder={this.props.t('Enter 6-digit code')}
                            maxLength="6"
                            pattern="[0-9]*"
                            inputMode="numeric"
                            autoFocus
                          />
                          {errors.otp && touched.otp ? (
                            <div className="textErrors">{errors.otp}</div>
                          ) : null}
                        </div>
                      </div>
                    ) : !showOtpInput && (
                      // Login Form
                      <div className="connexionLigne">
                        <div className="connexionW100">
                          <label className="hidden">{ this.props.t('Enter your ID') }</label>
                          <input type="text"
                            className={`textInput ${errors.username && "textInputError"}`}
                            name="username"
                            value={values.username}
                            onChange={handleChange}
                            placeholder={ this.props.t('Enter your ID') }
                          />
                          {errors.username && touched.username ? (
                            <div className="textErrors">{errors.username}</div>
                          ) : null}
                        </div>
                        <div className="connexionW100">
                          <label className="hidden">{ this.props.t('Password') }</label>
                          <input type="password"
                            className={`textInput ${errors.password && "textInputError"}`}
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            placeholder={ this.props.t('Password') }
                          />
                          {errors.password && touched.password ? (
                            <div className="textErrors">{errors.password}</div>
                          ) : null}
                        </div>
                      </div>
                    )}
                    
                    {!(showOtpInput && mfaSetupMode && mfaSetupStep === 0) && (
                      <div className="connexionLigne w12 justify-content-between">
                        {showOtpInput ? (
                          <a onClick={this.handleBackToLogin} className="forgot" style={{float:'none'}}>
                            {this.props.t('Back to Login')}
                          </a>
                        ) : (
                          <a onClick={() => this.onOpenModalPassword()} className="forgot" style={{float:'none'}}>
                            { this.props.t('FORGOT PASSWORD?') }
                          </a>
                        )}
                        
                        {!(showOtpInput && mfaSetupMode && mfaSetupStep === 1) && (
                          <div className=' connexion_button'>
                            {isSubmitting && <LdsSpinner type='relative'/>}
                            <button type="submit" className="signin home_btn_connexion" style={{float:'none'}} disabled={isSubmitting}>
                              {showOtpInput ? this.props.t('Verify') : this.props.t('Validate')}
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                    
                    {!showOtpInput && resend_activation_data && (
                    <>
                      <div className="connexionLigne w12 resend_activation_data">
                        Resend {resend_activation_data == "mail" ? "link " : "code "} activation?
                        <button className="resend_activation_data_btn" onClick={this.handleResendActivationData}>{ this.props.t('Resend') }</button>
                      </div>
                      {resend_activation_data_message &&
                        <div className="resend_activation_data_message">
                          {resend_activation_data_message}
                        </div>
                      }
                    </>
                    )}
                  </div>
                </Form>);
                }}
              </Formik>
            </div>
          </div>
          <div className="col col-md-6">
          </div>
        </div>
      </Modal>
          <ModalPassword 
            open={this.state.open} 
            pages={this.props.pages} 
            onCloseModalPassword={this.onCloseModalPassword}
            handlePasswordReseted={(message) => this.handlePasswordReseted(message)} />
          <ModalCompteSuccess
            success={this.state.success}
            message={this.state.messageSuccess}
            handleCloseSuccess={this.handleCloseSuccess}
          />
      </>
    );
  }
}

const mapState2Props = state => ({ session: state.session });
export default connect(mapState2Props)(withRouter(withTranslation('translations')(CommonModalConnexion)));
